import { axios } from '@/axios';
import { config } from '@/config';

export async function handleGeneration(
  setIsLoadingAI,
  userLang,
  answerNumber,
  answerCorrect,
  userId,
  prompt,
  setPrompt,
  setCompletion,
  setPrevResult
) {
  setIsLoadingAI(true);

  let context = document.querySelector('.fr-view');
  const children = context.children;
  let extractedText = '';
  for (const child of children) {
    if (!child.classList.contains('widget-placeholder')) {
      extractedText += child.textContent.trim() + ' ';
    }
  }
  let query = '';
  if (extractedText.length > 2000) {
    query += extractedText.slice(2500);
  } else {
    query += extractedText;
  }

  let systemPromt;
  switch (userLang) {
    case 'nl':
      systemPromt = `Je bent een behulpzame assistent die is ontworpen om JSON uit te voeren.
        U krijgt een hoofdtaak die tussen dubbele aanhalingstekens wordt gemarkeerd en een helper tekst die tussen drievoudige aanhalingstekens wordt gemarkeerd.
        U moet JSON genereren voor de hoofdtaak.
        JSON moet dit formaat hebben: {
          score: 1,
          vraag: '',
          type: 'MeerKeuze',
          antwoorden: [
            { text: '', isCorrect: true },
            { text: '', isCorrect: false },
          ]
        }
        Waar is de 'vraag' is een vraag die moet worden gegenereerd op basis van de hoofdtaak die door de gebruiker is ingediend, waarbij gebruik wordt gemaakt van een helper tekst die kan worden gebruikt als basis voor het genereren van een antwoord op de taak, maar als de helper tekst op geen enkele manier verband houdt met de hoofdtaak negeert vervolgens de helper tekst.
        'antwoorden'- is een array van ${answerNumber} objecten waarin er noodzakelijkerwijs ${answerCorrect} correct moet zijn en ${
        answerNumber - answerCorrect
      } onjuiste antwoorden op de gegenereerde vraag worden weergegeven, waarbij 'text' de tekst van het antwoord is en 'isCorrect' is of het antwoord juist-waar of niet-onwaar is.`;
      break;
    case 'fr':
      systemPromt = `Vous êtes un assistant utile conçu pour générer du JSON.
        Vous recevrez une tâche principale qui sera mise en évidence entre guillemets doubles et un texte d'aide qui sera mis en évidence entre guillemets triples.
        Vous devez générer du JSON pour la tâche principale.
        JSON doit avoir ce format:{
          score: 1,
          vraag: '',
          type: 'MeerKeuze',
          antwoorden: [
            { text: '', isCorrect: true },
            { text: '', isCorrect: false },
          ]
        }
        Où est le 'vraag est une question à générer à partir de la tâche principale soumise par l'utilisateur, en utilisant un texte d'aide qui peut être utilisé comme base pour générer une réponse à la tâche, mais si le texte d'aide n'est en aucun cas lié à la tâche principale ignore alors le texte d'aide.
        'antwoorden'- est un tableau d'objets ${answerNumber} dans lequel il doit y avoir nécessairement ${answerCorrect} correct et ${
        answerNumber - answerCorrect
      } les réponses incorrectes à la question générée sont présentées, où "text" est le texte de la réponse et "isCorrect" indique si la réponse est correcte-vrai ou non-faux.`;

      break;
    default:
      systemPromt = `You are a helpful assistant designed to output JSON. 
        You will be given a main task which will be highlighted in double quotes and a helper text which will be highlighted in triple quotes.
        You need to generate JSON for the main task.
        JSON should be of this format: {
          score: 1,
          vraag: '',
          type: 'MeerKeuze',
          antwoorden: [
            { text: '', isCorrect: true },
            { text: '', isCorrect: false },
          ]
        }
        Where is the 'vraag is a question to be generated from the main task submitted by the user, using a helper text that can be used as a basis for generating an answer to the task, but if the helper text is in no way related to the main task then ignore the helper text.
        'antwoorden'- is an array of ${answerNumber} objects in which there must be necessarily ${answerCorrect} correct and ${
        answerNumber - answerCorrect
      } incorrect answers to the generated question are presented, where 'text' is the text of the answer and 'isCorrect' is whether the answer is correct-true or not-false.`;

      break;
  }

  try {
    const dataOpenAI = await axios.post(`${config.backend}/openai`, {
      response_format: { type: 'json_object' },
      messages: [
        {
          role: 'system',
          content: systemPromt,
        },
        {
          role: 'user',
          content: `main task:""${prompt}""
            basis text:"""${query}"""`,
        },
      ],
      model: 'gpt-4o',
      temperature: 0.85,
      max_tokens: 4000,
      user: `${userId}`,
    });

    const fullAnswer = dataOpenAI?.data?.choices[0]?.message?.content || '';
    const jsonObject = JSON.parse(fullAnswer);

    setPrompt('');

    if (jsonObject) {
      setPrevResult({
        answer: false,
        systemContent: systemPromt,
        userContent: `main task:""${prompt}""
        helper text:"""${query}"""`,
      });
      setCompletion(jsonObject);
    }
  } catch (e) {
    alert('Error: ', e);
    setIsLoadingAI(false);
  }
}

export async function handleAgainGeneration(
  setIsLoadingAI,
  setIsLoadingAIAnswer,
  userId,
  setCompletion,
  setCompletionAdd,
  prevResult
) {
  prevResult?.answer ? setIsLoadingAIAnswer(true) : setIsLoadingAI(true);

  try {
    const dataOpenAI = await axios.post(`${config.backend}/openai`, {
      response_format: { type: 'json_object' },
      messages: [
        {
          role: 'system',
          content: prevResult?.systemContent,
        },
        {
          role: 'user',
          content: prevResult?.userContent,
        },
      ],
      model: 'gpt-4o',
      temperature: 0.9,
      max_tokens: 4000,
      user: `${userId}`,
    });

    const fullAnswer = dataOpenAI?.data?.choices[0]?.message?.content || '';
    const jsonObject = JSON.parse(fullAnswer);

    if (jsonObject) {
      prevResult?.answer
        ? setCompletionAdd(jsonObject)
        : setCompletion(jsonObject);
    }
  } catch (e) {
    alert('Error: ', e);
    prevResult?.answer ? setIsLoadingAIAnswer(false) : setIsLoadingAI(false);
  }
}

export async function handleAddNewOptions(
  questionVraag,
  compactAntwoorden,
  setIsLoadingAIAnswer,
  userLang,
  answerNumber,
  answerCorrect,
  userId,
  setCompletionAdd,
  setPrevResult
) {
  setIsLoadingAIAnswer(true);

  let context = document.querySelector('.fr-view');
  const children = context.children;
  let extractedText = '';
  for (const child of children) {
    if (!child.classList.contains('widget-placeholder')) {
      extractedText += child.textContent.trim() + ' ';
    }
  }
  let query = '';
  if (extractedText.length > 2000) {
    query += extractedText.slice(2500);
  } else {
    query += extractedText;
  }

  let systemPromt;
  switch (userLang) {
    case 'nl':
      systemPromt = `Je bent een behulpzame assistent die is ontworpen om JSON uit te voeren.
      U moet JSON genereren.
      JSON moet dit formaat hebben: {
        score: 1,
        vraag: ${questionVraag},
        type: 'MeerKeuze',
        antwoorden: [
          { text: '', isCorrect: true },
          { text: '', isCorrect: false },
        ]
      }
        U ontvangt een hulptekst waarmee u moet werken om juiste en onjuiste antwoorden op deze vraag te genereren - '${questionVraag}' als de opgegeven tekst niets met deze vraag te maken heeft - '${questionVraag}' dan is dit gegeven tekst moet worden genegeerd en antwoorden moeten alleen voor deze vraag worden gegenereerd - '${questionVraag}'
        De gegenereerde antwoorden moeten in 'antwoorden' worden geplaatst - een array van ${answerNumber} objecten, waarin ${answerCorrect} correct moet zijn en ${
        answerNumber - answerCorrect
      } waarbij "text" de tekst van het antwoord is en "isCorrect" is of het antwoord correct-waar of niet-onwaar is.
        Ook moet de gegenereerde 'antwoorden' array andere objecten hebben dan in deze array - ${compactAntwoorden}
      `;
      break;
    case 'fr':
      systemPromt = `Vous êtes un assistant utile conçu pour générer du JSON.
      Vous devez générer du JSON.
      JSON doit avoir ce format:{
        score: 1,
        vraag: ${questionVraag},
        type: 'MeerKeuze',
        antwoorden: [
          { text: '', isCorrect: true },
          { text: '', isCorrect: false },
        ]
      }
      Vous recevez un texte auxiliaire sur lequel vous devez opérer afin de générer des réponses correctes et incorrectes à cette question - '${questionVraag}' si le texte donné n'a rien à voir avec cette question - '${questionVraag}' alors celui-ci est donné le texte doit être ignoré et les réponses générées uniquement pour cette question - '${questionVraag}'
          Les réponses générées doivent être placées dans 'antwoorden' - un tableau d'objets ${answerNumber}, dans lequel ${answerCorrect} doit être correct et ${
        answerNumber - answerCorrect
      } où "text" est le texte de la réponse et "isCorrect" indique si la réponse est correcte-vrai ou non-faux.
        De plus, le tableau 'antwoorden' généré doit avoir des objets différents de ceux de ce tableau - ${compactAntwoorden}`;
      break;
    default:
      systemPromt = `You are a helpful assistant designed to output JSON. 
          You need to generate JSON.
          JSON should be of this format: {
            score: 1,
            vraag: ${questionVraag},
            type: 'MeerKeuze',
            antwoorden: [
              { text: '', isCorrect: true },
              { text: '', isCorrect: false },
            ]
          }
            You receive an auxiliary text that you need to operate on in order to generate correct and incorrect answers for this question - '${questionVraag}' if the given text has nothing to do with this question - '${questionVraag}' then this given text should be ignored and answers generated only for this question - '${questionVraag}'
            The generated answers must be placed in 'antwoorden' - an array of ${answerNumber} objects, in which ${answerCorrect} must be correct and ${
        answerNumber - answerCorrect
      } where "text" is the text of the response and "isCorrect" is whether the response is correct-true or not-false.
            Also the generated 'antwoorden' array must have different objects than in this array - ${compactAntwoorden}`;

      break;
  }

  try {
    const dataOpenAI = await axios.post(`${config.backend}/openai`, {
      response_format: { type: 'json_object' },
      messages: [
        {
          role: 'system',
          content: systemPromt,
        },
        {
          role: 'user',
          content: query,
        },
      ],
      model: 'gpt-4o',
      temperature: 0.9,
      max_tokens: 4000,
      user: `${userId}`,
    });

    const fullAnswer = dataOpenAI?.data?.choices[0]?.message?.content || '';
    const jsonObject = JSON.parse(fullAnswer);

    if (jsonObject) {
      setPrevResult({
        answer: true,
        systemContent: systemPromt,
        userContent: query,
      });
      setCompletionAdd(jsonObject);
    }
  } catch (e) {
    alert('Error: ', e);
    setIsLoadingAIAnswer(false);
  }
}

export async function handleNewGeneration(
  setIsLoadingAI,
  setIsLoadingAIAnswer,
  userLang,
  answerNumber,
  answerCorrect,
  userId,
  prompt,
  setPrompt,
  setCompletion,
  existingObject,
  setPrevResult
) {
  setIsLoadingAIAnswer(true);

  const jsonString = JSON.stringify(existingObject);
  const compactAntwoorden = jsonString;

  let context = document.querySelector('.fr-view');
  const children = context.children;
  let extractedText = '';
  for (const child of children) {
    if (!child.classList.contains('widget-placeholder')) {
      extractedText += child.textContent.trim() + ' ';
    }
  }
  let query = '';
  if (extractedText.length > 2000) {
    query += extractedText.slice(2500);
  } else {
    query += extractedText;
  }

  let systemPromt;
  switch (userLang) {
    case 'nl':
      systemPromt = `Je bent een behulpzame assistent die is ontworpen om JSON uit te voeren.
      U krijgt een hoofdtaak die tussen dubbele aanhalingstekens wordt gemarkeerd. Dit wordt uw hoofdtaak en een hulptekst die tussen drievoudige aanhalingstekens wordt gemarkeerd - ondersteunende tekst.
      U moet JSON genereren voor de hoofdtaak.
      JSON moet dit formaat hebben: {
        score: 1,
        vraag: question,
        type: 'MeerKeuze',
        antwoorden: [
          { text: answer, isCorrect: true },
          { text: answer, isCorrect: false },
        ]
      }
      Waar is de 'vraag' is een vraag(formaat string maar leesbare tekst).
      'antwoorden'- is een reeks antwoorden waarbij 'tekst' de tekst (opmaaktekenreeks maar leesbare tekst) van het antwoord is en 'isCorrect' is of het antwoord juist-waar of niet-onwaar is.
      Je krijgt ook een bestaand JSON-object: ${compactAntwoorden}.
      van de hoofdtaak die u wordt gegeven, moet u begrijpen wat er moet gebeuren:
        - of u een reeds bestaand JSON-object moet wijzigen (${compactAntwoorden}) - dat wil zeggen dat uit de hoofdtaak duidelijk moet zijn wat u moet doen, en dat u na de hoofdtaak een bestaand object moet wijzigen (${compactAntwoorden}) of elementen die in dit object voorkomen, d.w.z. vragen ('vraag') of antwoorden ('antwoorden') of beide, ze kunnen u bijvoorbeeld vertellen een of meer opties te verwijderen of toe te voegen, d.w.z. antwoorden die in de array 'antwoorden' staan of bijvoorbeeld de antwoorden ('antwoorden') of vragen ('vraag') ingewikkelder maken of andersom om antwoorden of vragen makkelijker te maken, of om antwoorden of vragen te vertalen of om iets dergelijks met een vraag of antwoorden te doen, volg ook de gegeven hoeveelheden als u twee elementen moet wijzigen, verander er twee, als het drie is, dan drie, enzovoort. U moet het object (${compactAntwoorden}) alleen de vraag ('vraag') wijzigen, wat een string maar leesbare tekst moet zijn, of de antwoorden wijzigen ('antwoorden'), het moet een array van objecten van hetzelfde formaat zijn die al bestaat [{ tekst: *, isCorrect: * },], d.w.z. u krijgt te horen wat u moet doen en u moet de vraag ('vraag') of het antwoord ('antwoorden') al aanpassen, maar als de hoofdtaak zegt dat er iets met de antwoorden moet gebeuren, dat doe je, maar je hoeft de vraag niet te veranderen. Wanneer u een bestaand JSON-object wijzigt, moet de door de gebruiker aangeleverde helptekst tussen drie aanhalingstekens worden genegeerd en nergens voor worden gebruikt, alleen als de helptekst iets gemeen heeft of hetzelfde onderwerp heeft als de hoofdvraag of vraag ('vraag'). in een bestaand object (${compactAntwoorden}) kan het worden gebruikt als helptekst om de context van de informatie te begrijpen, wat soms kan worden gebruikt om vragen of antwoorden aan te passen.
        - of u een nieuw JSON-object moet maken - u moet alleen een nieuw object maken als u begrijpt dat het niet nodig is om het bestaande JSON-object te wijzigen, dat wil zeggen als er geen instructies in de hoofdtaak zijn om bij te werken, toe te voegen, te verwijderen, het niveau van complexiteit wijzigen, vertalen of andere acties of iets dergelijks, dan maakt u een nieuw JSON-object aan en voert u de volgende acties alleen uit wanneer u een nieuw JSON-object aanmaakt en deze niet wijzigt: d.w.z. er moet een vraag worden aangemaakt ('vraag' is een format string maar leesbare tekst) die moet worden gegenereerd op basis van een hoofdtaak die u door de gebruiker is gegeven, met behulp van de meegeleverde hoofdtekst die kan worden gebruikt als basis voor het maken van een vraag of antwoorden, maar als de helptekst geen verband houdt met de hoofdtaak op welke manier dan ook, negeer dan de helpertekst, je moet ook een array van objecten ("antwoorden") aanmaken, dit zullen de antwoorden zijn op de gegenereerde vraag ("vraag"), deze array ("antwoorden") moet bevatten ${answerNumber} objecten waarin ${answerCorrect} correct moet zijn en ${
        answerNumber - answerCorrect
      } foute antwoorden op de gegenereerde vraag ('vraag');
      `;
      break;
    case 'fr':
      systemPromt = `Vous êtes un assistant utile conçu pour générer du JSON.
      Vous recevrez une tâche principale qui sera mise en évidence entre guillemets doubles, ce sera votre tâche principale et un texte d'aide qui sera mis en évidence entre guillemets triples - texte de support.
      Vous devez générer du JSON pour la tâche principale.
      JSON doit avoir ce format : {
        score: 1,
          vraag: question,
          type: 'MeerKeuze',
          antwoorden: [
            { text: answer, isCorrect: true },
            { text: answer, isCorrect: false },
          ]
      }
      Où est le 'vraag est une question (chaîne de format mais texte lisible).
      'antwoorden' - est un tableau de réponses où 'text' est le texte (chaîne de format mais texte lisible) de la réponse et 'isCorrect' indique si la réponse est correcte-vrai ou non-faux.
      Vous recevez également un objet JSON existant : ${compactAntwoorden}.
      à partir de la tâche principale qui vous sera confiée, vous devez comprendre ce qui doit être fait :
        - s'il faut modifier un objet JSON déjà existant (${compactAntwoorden}) - c'est-à-dire que la tâche principale doit indiquer clairement ce que vous devez faire, et après la tâche principale, vous modifiez un objet existant (${compactAntwoorden}) ou éléments qui se trouvent dans cet objet, c'est-à-dire des questions ('vraag') ou des réponses ('antwoorden') ou les deux, par exemple, ils peuvent vous dire de supprimer ou d'ajouter une ou plusieurs options, c'est-à-dire des réponses qui sont dans le tableau 'antwoorden' ou , par exemple, compliquer les réponses ('antwoorden') ou les questions ('vraag') ou vice versa pour rendre les réponses ou les questions plus faciles, ou pour traduire les réponses ou les questions ou pour faire quelque chose de similaire avec une ou plusieurs questions, suivez également les instructions données quantités si vous devez modifier deux éléments, changez-en deux, si trois, puis trois, et ainsi de suite. Vous devrez changer l'objet (${compactAntwoorden}) uniquement la question ('vraag' ) qui doit être une chaîne mais un texte lisible, ou changer les réponses ('antwoorden'), il doit s'agir d'un tableau d'objets du même format qui déjà existe [{ text: *, isCorrect: * },], c'est-à-dire qu'on vous dira quoi faire et vous devrez déjà modifier la question ("vraag") ou la réponse ("antwoorden"), mais si la tâche principale dit que quelque chose doit être fait avec les réponses, vous le faites, mais vous n'avez pas besoin de changer la question. Lorsque vous modifiez un objet JSON existant, le texte d'aide fourni par l'utilisateur entre guillemets triples doit être ignoré et ne doit être utilisé pour rien, uniquement si le texte d'aide a quelque chose en commun ou a le même sujet que la question ou la question principale (« vraag »). dans un objet existant (${compactAntwoorden}), il peut être utilisé comme texte d'aide pour comprendre le contexte de l'information, qui peut parfois être utilisé pour aider à modifier des questions ou des réponses.
        - s'il faut créer un nouvel objet JSON - vous ne devez créer un nouvel objet que lorsque vous comprenez qu'il n'est pas nécessaire de modifier l'objet JSON existant, c'est-à-dire s'il n'y a pas d'instructions dans la tâche principale pour mettre à jour, ajouter, supprimer, changez le niveau de complexité, traduisez ou d'autres actions ou quelque chose de similaire, puis vous créez un nouvel objet JSON et effectuez les actions suivantes uniquement lorsque vous créez un nouvel objet JSON et ne le modifiez pas : c'est-à-dire qu'une question doit être créée ('vraag' est un chaîne de format mais texte lisible) qui doit être généré à partir d'une tâche principale qui vous est confiée par l'utilisateur, en utilisant le corps du texte fourni qui peut être utilisé comme base pour créer une question ou des réponses, mais si le texte d'aide n'est pas lié au tâche principale de quelque manière que ce soit, puis ignorez le texte d'aide, vous devez également créer un tableau d'objets ("antwoorden"), ce seront les réponses à la question générée ("vraag"), ce tableau ("antwoorden") doit contenir des objets ${answerNumber} dans lesquels ${answerCorrect} doit être correct et ${
        answerNumber - answerCorrect
      } mauvaises réponses à la question générée ('vraag');`;
      break;
    default:
      systemPromt = `You are a helpful assistant designed to output JSON. 
        You will be given a main task which will be highlighted in double quotes this will be your main task and a helper text which will be highlighted in triple quotes - supporting text.
        You need to generate JSON for the main task.
        JSON should be of this format: {
          score: 1,
          vraag: question,
          type: 'MeerKeuze',
          antwoorden: [
            { text: answer, isCorrect: true },
            { text: answer, isCorrect: false },
          ]
        }
        Where is the 'vraag is a question(format string but readable text).
        'antwoorden'- is an array of answers where 'text' is the text(format string but readable text) of the answer and 'isCorrect' is whether the answer is correct-true or not-false.
        You are also given an existing JSON object: ${compactAntwoorden}.
        from the main task that will be given to you, you need to understand what needs to be done:
          - whether to modify an already existing JSON object (${compactAntwoorden}) - that is, it should be clear from the main task what you need to do, and following the main task you modify an existing object (${compactAntwoorden}) or elements that are in this object, i.e. questions ('vraag') or answers ('antwoorden') or both, for example, they can tell you  remove or add one or more options, i.e. answers that are in the array 'antwoorden' or, for example, complicate the answers ('antwoorden' ) or questions ('vraag') or vice versa to make answers or questions easier, or to translate answers or questions or to do something similar with a question or answers, also follow the given quantities if you two elements are requested to be changed, change two, if three, then three, and so on. You will need to change the object (${compactAntwoorden}) only question ('vraag' ) which must be a string but readable text, or change answers ('antwoorden') it must be an array of objects of the same format that already exists [{ text: *, isCorrect: * },], i.e. you will be told what to do and you already have to modify the question ('vraag') or the answer ('antwoorden'),but if the main task says that something needs to be done with the answers, you do it, but you don't need to change the question. When you modify an existing JSON object, user-supplied help text in triple quotes should be ignored and not used for anything, only if the help text has something in common or has the same subject as the main question or question ('vraag') in an existing object (${compactAntwoorden}) it can be used as a help text to understand the context of the information, which can sometimes be used to help modify questions or answers.
          - whether to create a new JSON object - you should create a new object only when you understand that there is no need to modify the existing JSON object, that is, if there are no instructions in the main task to update, add, delete, change the level of complexity, translate or other actions or something similar then you create a new JSON object and perform the following actions only when you create a new JSON object and not modify it: i.e. a question must be created ('vraag' is a format string but readable text) which should be generated from a main task given to you by the user, using the provided body text that can be used as a basis for creating a question or answers, but if the helper text is not related to the main task in any way, then ignore the helper text, you also need to create an array of objects ("antwoorden"), these will be the answers to the generated question ('vraag'), this array ('antwoorden') must contain ${answerNumber} objects in which ${answerCorrect} must be correct and ${
        answerNumber - answerCorrect
      } wrong answers to the generated question ('vraag');
        `;

      break;
  }

  try {
    const dataOpenAI = await axios.post(`${config.backend}/openai`, {
      response_format: { type: 'json_object' },
      messages: [
        {
          role: 'system',
          content: systemPromt,
        },
        {
          role: 'user',
          content: `main task:""${prompt}""
          helper text:"""${query}"""`,
        },
      ],
      model: 'gpt-4o',
      temperature: 0.85,
      max_tokens: 4000,
      user: `${userId}`,
    });

    const fullAnswer = dataOpenAI?.data?.choices[0]?.message?.content || '';
    const jsonObject = JSON.parse(fullAnswer);

    setPrompt('');

    if (jsonObject) {
      setIsLoadingAI(true);
      setCompletion(jsonObject);
      setPrevResult({
        answer: false,
        systemContent: systemPromt,
        userContent: `main task:""${prompt}""
        helper text:"""${query}"""`,
      });
    }
  } catch (e) {
    setIsLoadingAIAnswer(false);
    alert('Error: ', e);
  }
}
